import { render, staticRenderFns } from "./privacy1.vue?vue&type=template&id=2650251b&scoped=true"
import script from "./privacy1.vue?vue&type=script&lang=js"
export * from "./privacy1.vue?vue&type=script&lang=js"
import style0 from "./privacy1.vue?vue&type=style&index=0&id=2650251b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2650251b",
  null
  
)

export default component.exports